import React from "react";
import { TagProps, theme as antdTheme } from "antd";
import clsx from "clsx";

// TODO Rename this file to RumbleTag.tsx.

interface RumbleStepNumberTagProps extends TagProps {
  // Add any additional props you need
}

type AntdTokenType = ReturnType<typeof antdTheme.useToken>["token"];

interface RumbleTagStyleTokens {
  defaultBg?: string; // Default background color for the tag.
  defaultColor?: string; // Default text color for the tag.
  borderRadiusSM?: number; // Border radius for small elements.
  fontSizeSM?: number; // Font size for small elements.
  fontWeight?: number; // Font weight for the tag text, defaulting to 600
}

type ExtendedThemeTokens = AntdTokenType & {
  RumbleTag?: RumbleTagStyleTokens;
};

export const RumbleStepNumberTag: React.FC<RumbleStepNumberTagProps> = (
  props,
) => {
  const { className, style, ...restProps } = props;
  const { token } = antdTheme.useToken();

  const themeTokens = token as ExtendedThemeTokens & {
    Tag?: RumbleTagStyleTokens;
  };
  const rumbleTagTokens = themeTokens.RumbleTag ?? themeTokens.Tag ?? {}; // Rumble-specific overrides, with fallback to Antd's Tag and empty object

  const tagStyle = {
    backgroundColor: rumbleTagTokens.defaultBg ?? themeTokens.colorPrimary,
    borderRadius: rumbleTagTokens.borderRadiusSM ?? themeTokens.borderRadiusSM,
    color: rumbleTagTokens.defaultColor ?? themeTokens.colorTextLightSolid,
    fontSize: rumbleTagTokens.fontSizeSM ?? themeTokens.fontSizeSM,
    fontWeight: rumbleTagTokens.fontWeight ?? 600,
    ...style,
  };

  return (
    <span
      className={clsx("inline-flex uppercase h-6 px-2 items-center", className)}
      style={tagStyle}
      {...restProps}
    />
  );
};
